import React from "react";
import PropTypes from "prop-types";
import { Switch } from "react-router-dom";
import PrivateRoute from "PrivateRoute";
import DashboardLayout from "layouts/Dashboard";
import ProductsAndGuidesContainer from "./containers/ProductsContainer";

const ProductsAndGuidesPage = (props) => {
  const { match } = props;

  return (
    <Switch>
      <PrivateRoute
        path={match.url}
        component={ProductsAndGuidesContainer}
        layout={DashboardLayout}
        exact
      />
    </Switch>
  );
};

ProductsAndGuidesPage.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
};

export default ProductsAndGuidesPage;
